<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'600px'"
    :classDialog="'dialog-bhanh-doc-out'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #body>
      <div class="">
        <h3 class="dialogTitle">Chuyển tiếp văn bản</h3>
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="120px"
        >
          <div class="select-Unit-BanHanh">
            <el-row :gutter="12">
              <el-col :span="24">
                <el-form-item label="Trích yếu">
                  <el-input
                    size="medium"
                    type="textarea"
                    resize="none"
                    :rows="1"
                    autosize
                    v-model="docTitle"
                    disabled
                    class="
                      style-fullWidth
                      input-border__bottom input-border__radius__0
                      input-font__bold
                      bg__transparent
                    "
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="label flex-row flex__left">Người nhận</div>
            <div class="margin-bottom-10">
              <el-table
                ref="receiversDataTable"
                :data="selectedToUsers"
                size="mini"
                style="width: 100%"
                stripe
              >
                <el-table-column
                  align="center"
                  header-align="center"
                  type="index"
                  width="50"
                ></el-table-column>
                <el-table-column
                  label="Người/Đơn vị được chuyển "
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <div class="flex-row flex__left user_selected">
                      <div class="flex-row lex__left">
                        <div class="info margin-left-10">
                          <p class="people__name margin-0">
                            {{ scope.row.fullName }}
                          </p>
                          <p class="people__position margin-0">
                            {{ scope.row.positionName }} -
                            {{ scope.row.deptName }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="right" header-align="right" width="60">
                  <template slot-scope="scope">
                    <i
                      class="
                        el-icon-circle-close
                        clickable
                        font-size__large
                        color__red
                      "
                      @click="removeSelectedToUsers(scope.row)"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                class="btnPlain margin-top-10 margin-bottom-10"
                @click="isOpenSelectCCDialog = true"
              >
                <i class="fas fa-plus-circle"></i>
                Thêm người nhận
              </el-button>
            </div>
            <el-row :gutter="12">
              <el-col :span="24">
                <el-form-item label="Chỉ đạo/Ý kiến" prop="comment">
                  <el-input
                    v-model="form.comment"
                    size="medium"
                    class="
                      input-border__bottom input-border__radius__0
                      style-fullWidth
                    "
                    placeholder="-"
                    type="textarea"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>

        <banhanh-select-cc-dialog
          v-if="isEnableSelectCCDialog"
          :isOpen="isOpenSelectCCDialog"
          :selectedToUserIds="selectedToUserIds"
          :type="'IncommingDoc'"
          :docId="docId"
          @save="updateSelectedToUsers"
          @closed="isEnableSelectCCDialog = false"
          @closeDialog="isOpenSelectCCDialog = false"
        >
        </banhanh-select-cc-dialog>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="banHanh">
          <i class="fas fa-check-circle"></i>
          &nbsp;Xác nhận
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import h from "../../../services/h";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import BanhanhSelectCcDialog from "../../doc-out/components/banhanh-select-cc-dialog";
import incomingDocService from "../../../services/incomingDocService";

export default {
  props: ["docId", "isOpen", "docTitle", "docCode", "incomingProcessId"],
  components: {
    BanhanhSelectCcDialog,
    mixins: [handleRequestErrorMixin],
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    VuePerfectScrollbar,
  },

  data() {
    return {
      form: { comment: null },
      comment: null,
      isOpenSelectCCDialog: false,
      isEnableSelectCCDialog: false,
      selectedToUsers: [],
    };
  },

  computed: {
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },

    selectedToUserIds() {
      return h.collect(this.selectedToUsers, (item) => item.id);
    },
  },

  watch: {
    isOpenSelectCCDialog(newValue) {
      newValue && (this.isEnableSelectCCDialog = newValue);
    },
  },

  methods: {
    removeSelectedToUsers(item) {
      this.selectedToUsers = this.selectedToUsers.filter(
        (x) => x.id !== item.id
      );
    },

    updateSelectedToUsers(event) {
      this.selectedToUsers = event.selectedToUsers;
      this.isOpenSelectCCDialog = false;
    },

    validateSelectedToUsers() {
      if (!this.selectedToUsers || !this.selectedToUsers.length) {
        this.message(
          "Thông báo",
          "Danh sách người nhận chưa được chọn",
          "error",
          4000
        );
        return false;
      }
      return true;
    },

    banHanh() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
          return;
        }

        if (!this.validateSelectedToUsers()) return;

        let submitForm = {
          docId: this.docId,
          incomingProcessId: this.incomingProcessId,
          toUserDeptRoleIds: this.selectedToUserIds,
          comment: this.form.comment,
        };

        return incomingDocService
          .ccVanBan(submitForm)
          .then(() => {
            this.message(
              "Thông báo",
              "CC văn bản thành công.",
              "success",
              4000
            );
            this.$emit("success");
          })
          .catch((error) => this.commonHandleRequestError(error));
      });
    },
  },
};
</script>
<style scoped>
.select-Unit-BanHanh .content {
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  height: 200px;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/CCDocIn.vue